import { Component } from '@theme/component';

/**
 * A custom element that renders a native "buy more, save more" offer picker
 * (1 box / Pack x2 / Pack x3), each option pointing at a real Shopify product
 * (the base product, or a bundle product created with Shopify Bundles).
 *
 * Selecting an option retargets the existing native add-to-cart form to that
 * product's variant, so the theme's own add-to-cart flow (cart drawer, fly-to-
 * cart animation, error handling) keeps working unchanged. The accelerated
 * checkout button is hidden while a bundle is selected, since it can't safely
 * be retargeted to a different product without a full page/variant swap.
 *
 * @extends Component
 */
class BundleOfferPickerComponent extends Component {
  /**
   * @param {MouseEvent} event
   */
  selectOffer(event) {
    const button = /** @type {HTMLElement | null} */ (
      /** @type {HTMLElement} */ (event.target).closest('.bundle-offer-picker__option')
    );
    if (!button) return;

    this.querySelectorAll('.bundle-offer-picker__option').forEach((el) => {
      const selected = el === button;
      el.setAttribute('aria-checked', selected ? 'true' : 'false');
    });

    const { variantId, isBase } = button.dataset;
    if (!variantId) return;

    const scope = this.closest('.product-details') || document;

    const variantInput = /** @type {HTMLInputElement | null} */ (
      scope.querySelector('product-form-component input[name="id"]')
    );
    if (variantInput) variantInput.value = variantId;

    const acceleratedCheckout = scope.querySelector('[ref="acceleratedCheckoutButtonContainer"]');
    if (acceleratedCheckout instanceof HTMLElement) {
      acceleratedCheckout.hidden = isBase !== 'true';
    }
  }
}

if (!customElements.get('bundle-offer-picker-component')) {
  customElements.define('bundle-offer-picker-component', BundleOfferPickerComponent);
}
